import api from './authService';

export const brandingService = {
  async getBranding() {
    try {
      const res = await api.get('/branding');
      return res.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to load branding' };
    }
  },

  async updateIssuer(issuer) {
    try {
      const res = await api.put('/branding', { issuer });
      return res.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to update branding' };
    }
  },

  async uploadLogo(variant, file) {
    try {
      const fd = new FormData();
      fd.append('file', file);
      const res = await api.post(`/branding/logo/${variant}`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return res.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to upload logo' };
    }
  },

  async removeLogo(variant) {
    try {
      const res = await api.delete(`/branding/logo/${variant}`);
      return res.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to remove logo' };
    }
  },
};

export default brandingService;
